import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ClientService {
  url = `${environment.apiUrl}`;
  authUrl = `${environment.authUrl}`;
  siteUrl = `${environment.siteUrl}`;

  constructor(private http: HttpClient) {}

  /*==============================
User Domains
================================*/
  getUserDomains(params: any = {}) {
    const httpParams = new HttpParams({ fromObject: params });

    return this.http.get(`${this.url}/frontoffice/domaines`, {
      params: httpParams,
    });
  }

  /*==============================
get posters
================================*/
  getPosters(payload: any) {
    return this.http.get(`${this.url}/frontoffice/posters`, {
      params: payload,
      observe: "response",
    });
  }
  /*==============================
search Domaines
================================*/

  searchDomaines(params: any) {
    const httpParams = new HttpParams({ fromObject: params });

    return this.http.get(`${this.url}/frontoffice/domaines`, {
      params: httpParams,
    });
  }
  getDomaines(term: any) {
    let params = new HttpParams();

    params.set("nom", term);
    return this.http.get(`${this.url}/frontoffice/domaines`, { params });
  }
  getAroundPrestataires(idDemande: any) {
    return this.http.get(
      `${this.authUrl}/frontoffice/prestataires/nearest/${idDemande}`,
      { observe: "response" }
    );
  }
  /*==============================
get current Demands
================================*/
  getDemandDevis(id: number) {
    return this.http.get(`${this.url}/auth/frontoffice/demandes/devis/${id}`);
  }
  /*==============================
get Today Demand Per Domain
================================*/
  getTodayDemandPerDomain(payload: any) {
    return this.http.post(
      `${this.url}/auth/frontoffice/check-demande-day`,
      payload
    );
  }
  getCurrentDemands(opposit?: string[]) {
    let payload = {
      status: "",
      opposite: opposit
        ? [...opposit, "FINISHED", "REFUSED", "CANCELED"]
        : ["FINISHED", "REFUSED", "CANCELED"],
    };
    return this.http.post(
      `${this.url}/auth/frontoffice/client/demands`,
      payload
    );
  }
  getFinishedDemands() {
    let payload = {
      status: "",
      opposite: [
        "PENDING",
        "REFUSED",
        "PRE_ASSIGN",
        "PRE_ASSIGN_ADMIN",
        "ACCEPTED",
        "VALIDATION",
        "ONROAD",
        "WAITING",
        "INPROGRESS",
        "CANCELED",
        "DELAYED",
      ],
      // demands dtatus : 'PENDING','REFUSED','PRE_ASSIGN','PRE_ASSIGN_ADMIN','ACCEPTED', 'VALIDATION', 'ONROAD', 'WAITING', 'INPROGRESS', 'FINISHED', 'CANCELED', 'DELAYED'
    };
    return this.http.post(
      `${this.url}/auth/frontoffice/client/demands`,
      payload
    );
  }
  getCanceledDemands() {
    // let payload = {
    //   status: "",
    //   opposite: [
    //     "PENDING",
    //     "REFUSED",
    //     "PRE_ASSIGN",
    //     "PRE_ASSIGN_ADMIN",
    //     "ACCEPTED",
    //     "VALIDATION",
    //     "ONROAD",
    //     "WAITING",
    //     "INPROGRESS",
    //     "FINISHED",
    //     "DELAYED",
    //   ],
    //   // demands dtatus : 'PENDING','REFUSED','PRE_ASSIGN','PRE_ASSIGN_ADMIN','ACCEPTED', 'VALIDATION', 'ONROAD', 'WAITING', 'INPROGRESS', 'FINISHED', 'CANCELED', 'DELAYED'
    // };
    
    let payload = { "status": "CANCELED", "opposite": [] }
    return this.http.post(
      `${this.url}/auth/frontoffice/client/demands`,
      payload
    );
  }

  cancleDemand(data: any) {
    return this.http.post(
      `${this.authUrl}/frontoffice/demandes/update-statut/${data.id}`,
      data,
      {
        observe: "response",
      }
    );
  }

  cancleOnRoadDemand(data: any) {
    return this.http.post(
      `${this.authUrl}/frontoffice/onraod-canceled/${data.id}`,
      {
        observe: "response",
      }
    );
  }
  /*==============================
get passed Demands
================================*/
  getPassedDemands() {
    let payload = {
      status: "FINISHED",
      opposite: [],
    };
    return this.http.post(`${this.url}/auth/frontoffice/client/demands`, {
      payload,
    });
  }

  /*==============================
get Demands
================================*/
  getClientDemands(idDemande: any) {
    return this.http.get(`${this.authUrl}/frontoffice/client/demands`, {
      observe: "response",
    });
  }
  /*==============================
confirm arrival
================================*/
  confirmProviderArrival(payload: any) {
    return this.http.post(
      `${this.authUrl}/frontoffice/confirm-provider-arrival`,
      payload,
      {
        observe: "response",
      }
    );
  }
  /*==============================
confirm meeting
================================*/
  confirmMeeting(payload: any) {
    return this.http.post(
      `${this.authUrl}/frontoffice/update-status/meetings/${payload.id}`,
      payload,
      {
        observe: "response",
      }
    );
  }
  getMeetings(payload: any) {
    return this.http.post(
      `${this.authUrl}/frontoffice/get-client-meetings`,
      payload,
      {
        observe: "response",
      }
    );
  }
  getDevisPdf(id: number) {
    return this.http.get(`${this.authUrl}/frontoffice/devis/${id}/path`, {
      observe: "response",
    });
  }

  downloadDevisPdf(id: number) {
    return this.http.get(`${this.authUrl}/frontoffice/devis/${id}/download`, {
      responseType: "blob",
      observe: "response",
    });
  }

  sendDevisPdf(id: number) {
    return this.http.get(`${this.authUrl}/frontoffice/pdf/devi/${id}`, {
      observe: "response",
    });
  }

  updateDevisStatus(id: number, payload: any) {
    return this.http.post(
      `${this.authUrl}/frontoffice/update-statut-devi/${id}`,
      payload,
      {
        observe: "response",
      }
    );
  }

  updateArrivedStatus(payload: any) {
    return this.http.post(
      `${this.authUrl}/frontoffice/attent-pending`,
      payload,
      {
        observe: "response",
      }
    );
  }
  duplicateDemande(payload: any, id: any) {
    return this.http.post(
      `${this.authUrl}/frontoffice/demandes/${id}/duplicate`,
      payload,
      {
        observe: "response",
      }
    );
  }
  getDemandeById(id: any) {
    return this.http.get(`${this.authUrl}/frontoffice/demandes/${id}`, {
      params: {},
      observe: "response",
    });
  }
  getPrestataireAvis(id: number) {
    return this.http.get(`${this.authUrl}/frontoffice/prestataire-avis/${id}`, {
      params: {},
      observe: "response",
    });
  }
  evaluateDemande(payload: any) {
    return this.http.post(`${this.authUrl}/frontoffice/evolutions`, payload, {
      observe: "response",
    });
  }
}
